import { conditionFormChecker, putField } from "../../../../utils/form";
import { createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import {
    createFieldInput, createFieldSelect, createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";

export const callUnitByGroup = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "COORDINATE_CUSTOMS_UNIT", value: searchQuery });

export const callSubStanceTypeByGroup = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_DETAIL_SUB_STANCE_TYPE", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.coordinateCustoms.name"), dataIndex: "name", align: "center"}),
        createColumnInput({ title: () => i18n.global.t("model.coordinateCustoms.code"), dataIndex: "code", align: "center"}),
        createColumnSelect({
            title: () => i18n.global.t("model.coordinateCustoms.refUnit"),
            dataIndex: "refUnit.id",
            customRender: ({ record }) => <div>{record.refUnit?.value}</div>,
            inputProp: () => ({ list: callUnitByGroup, optLabel: "value" }),
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.coordinateCustoms.refDetailSubStanceType"),
            dataIndex: "refDetailSubStanceType.id",
            customRender: ({ record }) => <div>{record.refDetailSubStanceType?.value}</div>,
            inputProp: () => ({ list: callSubStanceTypeByGroup, optLabel: "value" }),
            align: "center"
        }),
    ]
    return columns
}

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}name`,
                label: () => `${i18n.global.t("model.coordinateCustoms.name")}`,
                labelRender: () => `${i18n.global.t("model.coordinateCustoms.name")}-${i18n.global.t("model.coordinateCustoms.code")}`,
                colProp: () => ({ xs: 24, md: 10 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.name,
                            "onUpdate:value": value => (model.name = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}code`,
                label: () => `${i18n.global.t("model.coordinateCustoms.code")}`,
                labelRender: () => "",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.code,
                            "onUpdate:value": value => (model.code = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refUnit`,
                colProp: () => ({ xs: 24, md: 10 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.coordinateCustoms.refUnit"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refUnit,
                            "onUpdate:value": value => model.refUnit = value,
                            disabled: viewOnly,
                            list: callUnitByGroup,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDetailSubStanceType`,
                label: () => i18n.global.t("model.coordinateCustoms.refDetailSubStanceType"),
                colProp: () => ({ xs: 24, md: 10 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDetailSubStanceType,
                            "onUpdate:value": value => model.refDetailSubStanceType = value,
                            disabled: viewOnly,
                            list: callSubStanceTypeByGroup,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}remark`,
                label: () => i18n.global.t("model.coordinateCustoms.remark"),
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.remark,
                            "onUpdate:value": value => (model.remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};